/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Refusal response when the model declines to answer due to safety policies, content moderation, or capability limitations.
 */
export type Refusal = {
  /**
   * The content type identifier for refusal responses.
   */
  type: "refusal";
  /**
   * The refusal message explaining why the model declined to respond to the request.
   */
  refusal: string;
};

/** @internal */
export const Refusal$inboundSchema: z.ZodType<Refusal, z.ZodTypeDef, unknown> =
  z.object({
    type: z.literal("refusal"),
    refusal: z.string(),
  });
/** @internal */
export type Refusal$Outbound = {
  type: "refusal";
  refusal: string;
};

/** @internal */
export const Refusal$outboundSchema: z.ZodType<
  Refusal$Outbound,
  z.ZodTypeDef,
  Refusal
> = z.object({
  type: z.literal("refusal"),
  refusal: z.string(),
});

export function refusalToJSON(refusal: Refusal): string {
  return JSON.stringify(Refusal$outboundSchema.parse(refusal));
}
export function refusalFromJSON(
  jsonString: string,
): SafeParseResult<Refusal, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Refusal$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Refusal' from JSON`,
  );
}
